import type { FC } from 'react';
import { ListItem } from '@interstate/components/List';
import { Box } from '@interstate/components/Box';
import { SelectInput } from '@interstate/components/SelectInput';
import type { FontSizeAdjustment } from '../constants';
import { FONT_SIZE_ADJUSTMENT, FONT_SIZE_ADJUSTMENT_OPTIONS } from '../constants';

type FontSizeAdjustmentFieldProps = {
    value: string | undefined;
    onFontSizeAdjustmentChange: (value: FontSizeAdjustment) => void;
};

const FontSizeAdjustmentField: FC<FontSizeAdjustmentFieldProps> = ({ value, onFontSizeAdjustmentChange }) => {
    const fontSizeAdjustmentValue = value ?? FONT_SIZE_ADJUSTMENT.DEFAULT;

    return (
        <ListItem id="fontSizeAdjustment">
            <Box sx={{ width: '50%', py: 1 }}>
                <SelectInput
                    label="Text Size"
                    name="fontSizeAdjustment"
                    value={fontSizeAdjustmentValue}
                    options={FONT_SIZE_ADJUSTMENT_OPTIONS.map((opt) => ({ label: opt.label, value: opt.value }))}
                    onChange={(e) => onFontSizeAdjustmentChange(e.target.value as FontSizeAdjustment)}
                    displayDeselectOption={false}
                    data-testid="font-size-adjustment-select"
                    sx={{
                        '& .MuiInputLabel-root.MuiInputLabel-root': {
                            color: '#000000'
                        }
                    }}
                />
            </Box>
        </ListItem>
    );
};

export default FontSizeAdjustmentField;
